import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';
import FormError from 'components/common/FormError';

import PasswordChangeForm from 'components/account/PasswordChangeDialog/PasswordChangeForm';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: 332,
    boxSizing: 'border-box',
    padding: 16,
    [theme.breakpoints.up('sm')]: {
      width: 330,
      boxSizing: 'content-box',
      padding: '50px 113px',
    },
  },
  typographyTitle: {
    textTransform: 'uppercase',
    paddingBottom: 14,
    marginBottom: 25,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  button: {
    marginTop: 30,
    paddingTop: 15,
    paddingBottom: 15,
    width: '100%',
  },
});

const ResetPassword = ({
  form,
  error,
  submitting,
  onSubmitSuccess,
  ID,
  actions,
  variant,
  classes,
}) => (
  <Paper
    className={classes.root}
    square
    elevation={5}
  >
    <Typography
      className={classes.typographyTitle}
      color="secondary"
      align="center"
    >
      {variant === 'reset' ? 'Change your password' : 'Create a Password'}
    </Typography>
    {error &&
      <FormError>
        {error}
      </FormError>
    }
    <PasswordChangeForm
      form={form}
      title="Please, enter your new password"
      onSubmitSuccess={onSubmitSuccess}
      initialValues={{
        ID,
      }}
      enableReinitialize
    />
    <Button
      className={classes.button}
      onClick={() => actions.submit(form)}
      variant="raised"
      color="primary"
      disabled={submitting || Boolean(error) || !ID}
    >
      {variant === 'reset' ? 'Change Password' : 'Save Password'}
    </Button>
  </Paper>
);

ResetPassword.propTypes = {
  variant: PropTypes.oneOf(['create', 'reset']),
  form: PropTypes.string.isRequired,
  error: PropTypes.string,
  ID: PropTypes.number,
  submitting: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

ResetPassword.defaultProps = {
  variant: 'reset',
  ID: null,
  error: null,
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ResetPassword),
);



// WEBPACK FOOTER //
// ./src/components/account/ResetPassword/ResetPassword.js